import { useDispatch } from 'react-redux'
import type { UnknownAction } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

// useDispatch() is typed as a plain Dispatch that rejects thunks; keep dispatch thunk-aware without threading a store type everywhere.
export type AppDispatch = ThunkDispatch<any, unknown, UnknownAction>

export const useAppDispatch = () => useDispatch<AppDispatch>()
